<a class="back-link" [routerLink]="link">← {{ label }}</a>
